import axios from "./axios";

const request = (method, url, data = {}, headers = {}) =>
  new Promise((resolve, reject) =>
    axios
      .request({
        method,
        url,
        data,
        headers,
      })
      .then(resolve)
      .catch(reject)
  );
const get = (url, headers = {}) => request("get", url, headers);
const post = (url, data = {}, headers = {}) =>
  request("post", url, data, headers);
const patch = (url, data = {}, headers = {}) =>
  request("patch", url, data, headers);
const destroy = (url, data = {}, headers = {}) =>
  request("delete", url, data, headers);

const list = (url, options, headers) => {
  const params = {
    q: options.searchString,
    sortBy: options.sortDirection,
    orderBy: options.sortFieldName,
    page: options.currentPage,
  };
  const queryString = Object.keys(params)
    .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
    .join("&");
  return get(`${url}?${queryString}`, headers);
};

export default {
  request,
  get,
  post,
  patch,
  destroy,
  list,
};
